import React from "react";
import { Outlet } from "react-router-dom";
import { Stack, Box } from "@mui/material";

import MainHeader from "./MainHeader";
import MainFooter from "./MainFooter";
import IconPhoneComponent from "../components/iconPhone/IconPhoneComponent";
import IconScrollToTop from "../components/iconPhone/IconScrollToTop";
import FooterMobile from "../components/footer/FooterMobile";

function MainLayout() {
  return (
    <Stack sx={{ minHeight: "190vh" }}>
      <MainHeader />
      <Outlet />
      <Box sx={{ flexGrow: 1 }} />
      <IconPhoneComponent />
      <IconScrollToTop />
      <MainFooter />
      <FooterMobile />
    </Stack>
  );
}

export default MainLayout;
